import React, { useContext } from 'react';
import Toast from 'src/components/Toast';
import NotificationContext from 'src/context/notification';
import * as S from './styles';

export const Notification = () => {
  const { notification } = useContext(NotificationContext);

  if (!notification) return null;

  const { text, ...rest } = notification;

  return (
    <S.NotificationWrapper data-testid="notification">
      <Toast {...rest}>{text}</Toast>
    </S.NotificationWrapper>
  );
};

export default Notification;
